/** Navigation intent only: no credentials. sessionStorage isolates it to this browser tab. */
export class LoginDestinationStore {
    private readonly key = 'waihona.loginDestination';
    private readonly maxAgeMs = 10 * 60 * 1000;
    private memory:any = null;

    public safePath(path:string):string {
        return typeof path === 'string' && path.startsWith('/') && !path.startsWith('//')
            && !/[\\\x00-\x1f]/.test(path) && !path.startsWith('/callback') && !path.startsWith('/logout') ? path : '/';
    }

    public begin(path:string):string {
        this.clear();
        const bytes = new Uint32Array(4);
        window.crypto.getRandomValues(bytes);
        const id = Array.from(bytes).map(value => value.toString(16)).join('-');
        this.memory = {id, target:this.safePath(path), createdAt:Date.now()};
        try { window.sessionStorage.setItem(this.key, JSON.stringify(this.memory)); } catch (_) {
            // Popup return still works in memory. A redirect without storage safely returns home.
        }
        return id;
    }

    public isCurrent(id:string):boolean {
        const record = this.read();
        return !!record && typeof id === 'string' && record.id === id;
    }

    public consume(id:string):string {
        const record = this.read();
        if (!record || record.id !== id) { return null; }
        this.clear(); // Consume before routing, even when navigation is rejected or cancelled.
        return record.target;
    }

    public clear(id?:string):void {
        if (id !== undefined && !this.isCurrent(id)) { return; }
        this.memory = null;
        try { window.sessionStorage.removeItem(this.key); } catch (_) {}
    }

    private read():any {
        let record = this.memory;
        try {
            if (!record) { record = JSON.parse(window.sessionStorage.getItem(this.key) || 'null'); }
        } catch (_) {}
        if (!record || typeof record.id !== 'string' || !record.id
            || !Number.isFinite(record.createdAt) || Date.now() - record.createdAt < 0
            || Date.now() - record.createdAt > this.maxAgeMs || this.safePath(record.target) !== record.target) {
            this.clear();
            return null;
        }
        return record;
    }
}
